export class Manager {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "Manager";
    this.scene = "LT - Manager Super";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;

    this.data = [
      {
        name: "HOME_BADGE",
        value: {
          image:
            "http://localhost:6060/uploads/PREMIER SPORTS/" +
            window.encodeURIComponent(
              "Badges/" + options.team.variables["badge_home"]
            ),
        },
      },
      {
        name: "FIRST",
        value: {
          text: options.player.first_name,
        },
      },
      {
        name: "LAST",
        value: {
          text: options.player.last_name,
        },
      },
      {
        name: "LINE_2",
        value: {
          text: options.player.title,
        },
      },
    ];
    this.sendPreview(this.scene, 50, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;
    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
